import {createEvent} from "effector";

export const setUserGroupsEv = createEvent()

export const setUserKeysEv = createEvent()

export const setUserAttributesEv = createEvent()

export const setUserUIDDataEv = createEvent()
